import { render, staticRenderFns } from "./chatHistory.vue?vue&type=template&id=546cd49b&scoped=true"
import script from "./chatHistory.vue?vue&type=script&lang=js"
export * from "./chatHistory.vue?vue&type=script&lang=js"
import style0 from "./chatHistory.vue?vue&type=style&index=0&id=546cd49b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546cd49b",
  null
  
)

export default component.exports